// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#root {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\nhtml, body {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}", ""]);
// Exports
module.exports = exports;
